// WrappedProductCard.tsx
import { useLocation, useNavigate } from 'react-router-dom';
import { type JSX, type MouseEvent } from 'react';
import { AddButton, ProductCard } from '@/components/ui';
import styles from './WrappedProductCard.module.css';
import type { WrappedProductCardProps } from './WrappedProductCard.types';

const WrappedProductCard = ({
  product,
  onProductClick,
  isClicked,
}: WrappedProductCardProps): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCurationPage = location.pathname.startsWith('/create-curations');

  const handleProductClick = (e: MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (isCurationPage && onProductClick) {
      onProductClick(product.id);
    } else {
      navigate(`/product/${product.id}?createCurations`, {
        state: {
          productData: product,
          timestamp: Date.now(),
          previousPath: window.location.pathname,
        },
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.productWrapper}>
        <div
          className={`${styles.imageContainer} ${isCurationPage && isClicked !== undefined ? styles.selected : ''}`}
          onClickCapture={handleProductClick}
        >
          <ProductCard product={product} />
          {isCurationPage && isClicked !== undefined && (
            <div className={styles.productCount}>{isClicked + 1}</div>
          )}
        </div>
        <AddButton product={product} />
      </div>
    </div>
  );
};

export default WrappedProductCard;
